import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  FormControl,
  FormLabel,
  useToast,
  Text,
} from "@chakra-ui/react";
import { default as ReactSelect } from "react-select";
import WorkshopB2BService from "../../services/WorkshopB2B";
import ExpertB2BDataService from "../../services/ExpertB2B";
import { DateTime } from "luxon";

export const FilterB2BWorkshopModal = ({ isOpen, onClose, func }: any) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const toast = useToast();

  const [selectedValue, setSelectedValue] = useState("");


  const generateMonthYearArray = () => {
    try {
      const startDate = DateTime.fromObject({
        month: 1,
        year: 2025,
      });
      const endDate = DateTime.now();
      let currentDate = startDate;
      const monthYearArray = [];
      let i = 0;

      while (currentDate <= endDate) {
        monthYearArray.push({
          month: currentDate.toFormat("MM"),
          year: currentDate.year,
          text: `${currentDate.toFormat("MMMM")}-${currentDate.year}`,
          index: i.toString(),
        });
        currentDate = currentDate.plus({ months: 1 });
        i++;
      }

      return monthYearArray;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleDownload = () => {
    if (month && year) {
      WorkshopB2BService.downloadB2WorkshopsBillingSheet(
        month,
        year,
        expert
      )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${month}-${year}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast({
            position: "top",
            title: "Billing Sheet Downloaded Successfully",
            description: "The billing sheet has been downloaded successfully",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        })
        .catch((error) => {
          console.error("Error downloading payments:", error.message);
          toast({
            position: "top",
            title: "Billing Sheet Download Failed",
            description:
              "There was an error downloading the billing sheet. Please try again later.",
            status: "error",
            duration: 1500,
            isClosable: true,
          });
        })
        .finally(() => {
          onClose();
        });
    }
  };

  const handleSelection = (value: any) => {
    setSelectedValue(value);

    const selectedMonth = generateMonthYearArray().find(
      (el) => el.index === value
    );

    if (selectedMonth) {
      setMonth(selectedMonth.month);
      setYear(selectedMonth.year.toString());
    }
  };

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [expert, setExpert] = useState("");
  const [expertList, setExpertList] = useState<any>([]);
  const [status, setStatus] = useState("");

  const expertOptions = expertList.map((el: any) => ({
    value: el._id,
    label: el.full_name,
  }));

  const fetchExperts = async () => {
    try {
      const expertRes = await ExpertB2BDataService.getAllB2BExperts(token, "", "", "");
      setExpertList(expertRes.data.data);
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        toast({
          position: "top",
          title: "Authentication Failed.",
          description: "Your session is expired.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
      console.log(error);
    }
  };

  useEffect(() => {
    fetchExperts();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Month and Status</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <>
              <FormControl>
                <FormLabel>Month</FormLabel>
                <Select
                  value={selectedValue}
                  onChange={(e) => handleSelection(e.target.value)}
                >
                  <option value="">Select Month</option>
                  {generateMonthYearArray().map((el) => (
                    <option value={el.index}>{el.text}</option>
                  ))}
                </Select>
              </FormControl>
              <FormControl mt={4}>
                <FormLabel> Expert</FormLabel>
                <ReactSelect
                  id="expert"
                  name="expert"
                  options={expertOptions}
                  placeholder="Choose Expert"
                  isClearable
                  value={expertOptions.find(
                    (option: any) => option.value === expert
                  )}
                  onChange={(option) => setExpert(option ? option.value : "")}
                  classNamePrefix="react-select"
                />
                {/* <Select
                  placeholder="Select expert"
                  onChange={(e) => {
                    setExpert(e.target.value);
                  }}
                  value={expert}
                >
                  {expertOptions.map((expert: any) => (
                    <option key={expert.value} value={expert.value}>
                      {expert.label}
                    </option>
                  ))}
                </Select> */}
              </FormControl>

              <FormControl mt={4}>
                <FormLabel>Status</FormLabel>
                <Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">Select Status</option>
                  <option value="tbc">To Be Confirmed</option>
                  <option value="confirmed">Confirmed</option>
                </Select>
              </FormControl>
            </>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="green"
              mr={3}
              onClick={() => {
                handleDownload();
                setMonth("");
                setYear("");
                setExpert("");
                setStatus("");
                setSelectedValue("");
                onClose();
              }}
            >
              Download
            </Button>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={() => {
                func(month, year, expert, status);
                setMonth("");
                setYear("");
                setExpert("");
                setStatus("");
                setSelectedValue("");
                onClose();
              }}
            >
              Search
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
